import { render, staticRenderFns } from "./FormalDayOff.vue?vue&type=template&id=ef201b78&"
import script from "./FormalDayOff.vue?vue&type=script&lang=js&"
export * from "./FormalDayOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports